module.exports = __webpack_public_path__ + "static/media/992462.829831f9.png";